import React from 'react'
import PropTypes from 'prop-types'

function Accordion({ data }) {
  return (
    <div className="accordion">
      {/* eslint-disable-next-line */}
      <a className="accordion__title-mobile" href="" tabIndex="0">
        {data.title?.toUpperCase()}
      </a>
      <div className="accordion__links">
        <h3 className="accordion__title-desktop">{data.title?.toUpperCase()}</h3>
        {data.links?.links?.map(link => {
          const key = `${link.title}_${link.url}`
          return (
            <a href={link.url} className="accordion__blue-link" key={key}>
              {link.title}
            </a>
          )
        })}
      </div>
      {data.hours?.length && (
        <div className="accordion__hours">
          <h4>Customer Service Hours</h4>
          {data.hours.map(schedule => (
            <div key={schedule.first}>
              <h4>{schedule.first}</h4>
              <p>{schedule.second}</p>
            </div>
          ))}
        </div>
      )}
      <div className="accordion__contact">
        {data.chat && (
          <div>
            <h4>Chat</h4>
            <p>{data.chat}</p>
          </div>
        )}
        {data.email && (
          <div>
            <h4>Email</h4>
            <p>{data.email}</p>
          </div>
        )}
        {data.call && (
          <div>
            <h4>Call</h4>
            <p>{data.call}</p>
          </div>
        )}
      </div>
    </div>
  )
}

Accordion.propTypes = {
  data: PropTypes.object.isRequired
}

export default Accordion
